import React, { useState } from 'react';

import { ContactListStore } from '../store';
import { Modal, Alert } from 'antd';
import _ from 'lodash';
import { observer } from 'mobx-react-lite';

export const ActionInvalidBizType: React.FC<{
    defaultStore: ContactListStore;
}> = observer(({ defaultStore }) => {
    const { defaultMSelect } = defaultStore;
    const { mSeletedData } = defaultMSelect;
    if (mSeletedData === null || mSeletedData.length === 0) {
        return null;
    }
    const visible = defaultStore.actionType === 'invalid-biztype';
    return (
        <Modal
            visible={visible}
            title={'操作失败'}
            onCancel={() => {
                defaultStore.resetAction();
            }}
            onOk={async () => {
                defaultStore.resetAction();
            }}
        >
            <Alert
                type="error"
                message="不可跨业务类型进行批量操作，联系人需要来自同一业务类型的客户。"
            />
        </Modal>
    );
});
